module.exports = __webpack_public_path__ + "img/features-export.7c387cd7.svg";